import { render, staticRenderFns } from "./InboxName.vue?vue&type=template&id=28ae951e&scoped=true"
import script from "./InboxName.vue?vue&type=script&lang=js"
export * from "./InboxName.vue?vue&type=script&lang=js"
import style0 from "./InboxName.vue?vue&type=style&index=0&id=28ae951e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ae951e",
  null
  
)

export default component.exports